export { SiteMapPage as default } from '@/components/pages/SiteMap'
